export const GetCookie = (cookieName) => {
	const cookies = {};
	document.cookie.split(";").forEach((c) => {
		cookies[c.split("=")[0].trim()] = c.split("=")[1];
	});

	return cookies[cookieName] || "";
};
